import type { AllRouteEndpoints } from "../routeTypes";
export const postFunnelReportsAppGroupIdCreateCacheKeys: AllRouteEndpoints[] = [];
